import { BookerModal } from "./BookerModal";

interface ExpertConsultationModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const ExpertConsultationModal = ({ open, onOpenChange }: ExpertConsultationModalProps) => {
  return (
    <BookerModal open={open} onOpenChange={onOpenChange} />
  );
};